import * as React from 'react'

interface IUseGlobalSearchQueryStateResult {
  query: string
  submittedQuery: string
  setSubmittedQuery: React.Dispatch<React.SetStateAction<string>>
  inputRef: React.RefObject<HTMLInputElement>
  changeQuery: (value: string) => void
}

export const useGlobalSearchQueryState =
  (): IUseGlobalSearchQueryStateResult => {
    const [query, setQuery] = React.useState('')
    const [submittedQuery, setSubmittedQuery] = React.useState('')
    const inputRef = React.useRef<HTMLInputElement>(null)

    const changeQuery = React.useCallback((value: string) => {
      setQuery(value)
      if (value === '') {
        setSubmittedQuery('')
      }
    }, [])

    return {
      query,
      submittedQuery,
      setSubmittedQuery,
      inputRef,
      changeQuery,
    }
  }
